<template>
    <el-dialog
        v-loading="loading"
        :visible.sync="dialogVisible"
        v-bind="$attrs"
        :custom-class="`dialog-custom ${customClass}`"
        center
        :close-on-click-modal="closeOnClickModal"
        :close-on-press-escape="closeOnPressEscape"
        :width="diaWidth"
        :show-close="showClose"
        v-on="$listeners"
    >
        <div v-if="showTitle" slot="title">
            <div class="el-title">
                 {{ title }}
            </div>
            <i class="el-icon-close" @click="dialogVisible=false" />
        </div>

        <div class="dialog-content">
           <slot />
        </div>

        <div
            v-if="showFooter"
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                v-if="buttons.cancel"
                class="button-cancel"
                @click="handleClose"
            >
                {{ buttons.cancel.text }}
            </el-button>
            <el-button
                v-if="buttons.confirm"
                class="button-confirm"
                :disabled="buttons.confirm.disabled"
                @click="handleConfirm"
            >
                {{ buttons.confirm.text }}
            </el-button>
            <el-button
                v-if="buttons.export"
                class="button-confirm"
                @click="handleExport"
            >
                {{ buttons.export.text }}
            </el-button>
        </div>
    </el-dialog>
</template>

<style lang="scss">
@import "./index.scss";
</style>

<script>
export default {
  name:"DialogCustom",

  inheritAttrs: false,

  props:{
    buttons:{
      type: Object,
      default: () => ({
        cancel: {
          text: "取消"
        },
        confirm:{
          text: "保存"
        }
      })
    },

    visible:{
      type: Boolean,
      default: false
    },
    title:{
      type: String,
      default: "信息"
    },

    customClass:{
      type: String,
      default: ""
    },

    handleExport:{
      type: Function,
      default: null
    },

    showClose:{
      type: Boolean,
      default: false
    },

    showTitle:{
      type: Boolean,
      default: true
    },

    closeOnClickModal:{
      type: Boolean,
      default: false
    },

    closeOnPressEscape:{
      type: Boolean,
      default: false
    },

    showFooter:{
      type: Boolean,
      default: true
    },

    diaWidth: {
      type: String,
      default: "450px"
    },

    /**是否在点击确认按钮后关闭弹窗 */
    closeAfterConfirm:{
      type: Boolean,
      default: true
    },

    /**是否在点击确认按钮后立即关闭弹窗 */
    immediateCloseAfterHandler:{
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },

  methods:{
    // 关于$listeners，若存在"confirm"和"cancel"需返回Promise

    handleConfirm() {
      this.handleListeners("confirm");
    },

    handleClose() {
      this.handleListeners("cancel");
    },

    async handleListeners(type) {
      this.loading = true;

      try {
        const listener = this.$listeners[type];
        const closeAfterListener = this.closeAfterConfirm || type === "cancel";

        if (this.immediateCloseAfterHandler) {
          if (closeAfterListener) {
            this.dialogVisible = false;
          }

          listener && await listener();
        } else {
          listener && await listener();

          if (closeAfterListener) {
            this.dialogVisible = false;
          }
        }
      } catch (err) {
        console.error(err);

        err.reason && this.$$error(err.reason||"请求错误");
        // 结合后端请求异常返回的{ reason: "xxx" }格式,前端其他报错（如表单验证等）也需reject({ reason: "xxx" }),统一结构
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
